import { HygieneScoreValueMapping, OralScores } from 'consts/oralScoreConsts'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

const OralHygieneScoreToAnalysisMessage = {
  [OralScores.Bad]: 'pages.patients.selectedPatient.hiTagScan.aiScanAnalysis.oralHygiene.messages.payAttention',
  [OralScores.Fair]: 'pages.patients.selectedPatient.hiTagScan.aiScanAnalysis.oralHygiene.messages.fair',
  [OralScores.Good]: 'pages.patients.selectedPatient.hiTagScan.aiScanAnalysis.oralHygiene.messages.good',
  [OralScores.Excellent]: 'pages.patients.selectedPatient.hiTagScan.aiScanAnalysis.oralHygiene.messages.Excellent'
}

export default ({ scanSummaryData }) => {
  const { t } = useTranslation()

  const scanParsedScanSummaryData = JSON.parse(scanSummaryData || '{}')

  const scanOralHygieneScore = useMemo(() => {
    if (!scanParsedScanSummaryData?.oral_scores_dict?.oral_hygiene_score) {
      return null
    }

    return scanParsedScanSummaryData?.oral_scores_dict?.oral_hygiene_score
  }, [scanParsedScanSummaryData?.oral_scores_dict?.oral_hygiene_score])

  const oralHygieneAnalysis = HygieneScoreValueMapping[scanOralHygieneScore]
  const oralHygieneAnalysisMessage = t(OralHygieneScoreToAnalysisMessage[oralHygieneAnalysis])

  return {
    oralHygieneAnalysis,
    oralHygieneAnalysisMessage
  }
}
